import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { TreeviewItem, TreeviewConfig, TreeItem } from 'ngx-treeview';

@Component({
  selector: 'app-sim-operator-tree-view',
  template: require('./sim-operator-tree-view.component.html'),
  styles: [require('./sim-operator-tree-view.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimOperatorTreeViewComponent implements OnInit {


  @Input() operators: any[];
  @Output() select = new EventEmitter<{
    event: Event,
    item: TreeItem
  }>();
  
  items: TreeItem[];
  projectId: number;
  
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasCollapseExpand: false,
    hasFilter: true,
    maxHeight: 500
  });

  constructor(
  ) { }

  ngOnInit(): void {
    const operators = this.operators && JSON.parse(JSON.stringify(this.operators));
    this.createTree(operators);
  }

 createTree = (operators) => {
  this.items = operators && operators.map(operator => {
    return new TreeviewItem({
      text: operator.name,
      value: {
        alarmState: this.getAlarmState(operator.priority),
        data: {...operator},
        level: 1
      },
      collapsed: true,
      children: operator.sub && operator.sub.map(cat => {
        return {
          text: cat.name,
          value: {
            alarmState: this.getAlarmState(cat.priority),
            data: {...cat},
            level: 2
          },
          collapsed: true,
          children: cat.sub && cat.sub.map(service => {
            return {
              text: service.name,
              value: {
                alarmState: this.getAlarmState(service.priority),
                data: {...service},
                level: 3
              }
            }
          })
        }
      })
      
    })
  })
 }

  getAlarmState = (priority) => {
    switch (priority) {
      case 1:
        return 'success';
      case 2:
        return 'warning';
      case 3:
        return 'danger';
      default:
        return '';
    }
  }
  onSelectedChange = () => {
    console.log("on selected change")
  }

  onFilterChange = () => {
    console.log("on filter change")
  }

  onSelect = ($event: Event, item: TreeItem) => {
    this.select.emit({
      event: $event, 
      item: {
        ...item.value,
        isOpened: !item.collapsed
      }
    });
  }
}
